// Cookie Consent banner initialization
// Code from: https://cookieconsent.insites.com/

export function initializeCookieConsent(config) {
  if (!window.cookieconsent) {
    console.warn('cookieconsent library not loaded');
    return;
  }

  window.cookieconsent.initialise({
    palette: {
      popup: {
        background: '#696969',
        text: '#ffffff'
      },
      button: {
        background: '#000000',
        text: '#ffffff'
      }
    },
    position: 'bottom-left',
    theme: 'classic',
    content: {
      link: config.link,
      message: config.message,
      dismiss: config.dismiss,
      href: '/terms-of-use'
    }
  });
}

// Auto-initialize on Turbo load by reading config from data attributes
document.addEventListener('turbo:load', () => {
  const configElement = document.querySelector('meta[name="cookie-consent-config"]');
  
  if (configElement) {
    const config = {
      link: configElement.dataset.link,
      message: configElement.dataset.message,
      dismiss: configElement.dataset.dismiss
    };
    
    initializeCookieConsent(config);
  }
});
